import type { UserContext } from '@zola-helpers/client/dist/es/@types';
import type { MobileNavLink } from '../MobileNavMenuData';

export default function getMobileYourWeddingMenuData(userContext: UserContext): MobileNavLink[][] {
  const mobileYourWeddingMenu = [
    [
      { title: 'Your Venue + Vendors', path: '/wedding-vendors' },
      {
        title: 'Your Website',
        path: userContext.has_website
          ? '/wedding/manage/website/manage'
          : '/wedding-planning/website/designs',
      },
      {
        title: 'Your Guest List',
        path: userContext.has_guest_list
          ? '/wedding/manage/guests/all'
          : '/wedding-planning/guests',
      },
      { title: 'Your RSVPs', path: '/wedding/manage/guests/rsvps/overview' },
      {
        title: 'Your Invites + Paper',
        path: userContext.has_invitation_account
          ? '/wedding-planning/projects/drafts'
          : '/wedding-planning/save-the-date/shop',
      },
      {
        title: 'Your Registry',
        path: userContext.has_registry ? `/registry/${userContext.slug}/edit` : '/onboard/new',
      },
      {
        title: 'Your Seating Chart',
        path: '/wedding/manage/seating',
      },
      {
        title: 'Your Albums',
        path: userContext.invitation_account?.photobooks_onboarding_completed
          ? '/wedding-albums/drafts'
          : '/wedding-albums/shop',
      },
    ],
  ];

  return mobileYourWeddingMenu;
}
